<template>
  <div id="app">
    <router-view/>
    <modal name="globalLoading" :clickToClose="false" :width="350" :height="150">
      <div class="p-8 h-full flex flex-col justify-center">
        <h3 class="text-navy text-center font-semibold">Loading!</h3>
        <clip-loader></clip-loader>
      </div>
    </modal>
    <modal name="appIsIdle" :clickToClose="false" :width="450" :height="250">
      <div class="p-8 h-full flex flex-col justify-center">
        <h3 class="text-navy text-center font-semibold">Session Timeout!</h3>
        <div class="p-8">
          <div class="text-navy font-semibold">You are being logged out due to inactivity. Please choose to stay signed in or to logout. Otherwise, you'll be automatically logged out in 60 seconds</div>
          <div class="flex justify-between mt-8">
            <button class="p-4 rounded-lg hover:bg-grey-lighter" @click="logout()">Log out</button>
            <button class="rounded-lg border bg-green p-4 hover:opacity-75 text-white" @click="stayLoggedIn">Stay logged in</button>
          </div>
        </div>
      </div>
    </modal>
    <!-- this needs to exist for computed value to work -->
    <span v-show="false">{{activeRequest}}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
let timeOutVar = '';
export default {
  name: 'App',
  components: {
    ClipLoader,
  },
  methods: {
    logout() {
      this.$auth.destroyToken();
      this.$router.push('/broker/sign-in');
      this.$modal.hide('appIsIdle');
    },
    stayLoggedIn() {
      this.$modal.hide('appIsIdle')
      clearTimeout(timeOutVar);
    },
  },
  onIdle() {
    if (this.$auth.loggedIn()) {
      this.$modal.show('appIsIdle')
      const vm = this;
      // 60000
      timeOutVar = setTimeout(vm.logout, 60000);
    }
  },
  computed: {
    ...mapState({
      // listen to activeRequest variable, and show/hide based on this
      activeRequest: function (state) {
        const isLoading = state.authentication.activeRequest;
        if (isLoading) {
          this.$modal.show('globalLoading')
        } else {
          this.$modal.hide('globalLoading')
        }
        return isLoading;
      },
    }),
  },
};
</script>

<style lang="postcss">
@tailwind preflight;
@tailwind components;
@tailwind utilities;

.label {
  @apply .block .uppercase .tracking-wide .text-navy-light .text-xs .mb-2 .leading-normal;
}
.field {
  @apply .appearance-none .block .w-full .bg-grey-lighter .text-navy .border .rounded .py-3 .px-4;
}

.blue-link {
  color: #4E57DF;
}

.red-link {
  color: #ff5e4b;
}

.bg-radial {
  background: radial-gradient(#38628a, #2b4864);
}

.field-disabled {
  @apply .bg-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue